const URL_BASE = '/auth';
const URL_SIGNUP = `${URL_BASE}/signup`;
const URL_EXTERNAL_TOKEN = `${URL_BASE}/external/show`;
const URL_CREATE_USER_FROM_QUIZ = `${URL_BASE}/external/create`;

export default URL_BASE;
export { URL_SIGNUP, URL_EXTERNAL_TOKEN, URL_CREATE_USER_FROM_QUIZ };
